import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { lighten, useTheme } from "@mui/material/styles";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { TnADayDataDTO } from "src/models/tna/tna-data/tna-day-data-dto";
import { TnADayDataWithBreaksRef } from "src/models/tna/tna-day-data-with-breaks";
import SendAnomaliesNotificationsWrapper from "./SendAnomaliesNotificationsWrapper";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";

interface Props {
  item: TnADayDataWithBreaksRef | TnADayDataDTO;
  handleNotifyParent: () => void;
}

interface State {
  loading: boolean;
  shouldClosePopover: boolean;
}

const AnomaliesActions = ({ item, handleNotifyParent }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.team_presence_and_leaves_dashboard";
  const theme = useTheme();

  const [state, setState] = useState<State>({
    loading: false,
    shouldClosePopover: false,
  });

  const handleNotify = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldClosePopover: true,
    }));
    handleNotifyParent();
  }, [handleNotifyParent]);

  // const handleNotifyEmployee = useCallback(async () => {
  //   if (!item.employee?.id) return;

  //   setState((prevState) => ({ ...prevState, loading: true }));

  //   try {
  //     const apiService = new EmployeeStatusDigestApiService();

  //     const response = await apiService.loadItems({
  //       employeeId: item.employee.id,
  //     } as EmployeeFilter);

  //     if (!response.error) {
  //       toastifyResponse(response, "all", "employee_notified_successfully");
  //       // if (handleNotifyParent) {
  //       //   handleNotifyParent();
  //       // }
  //     } else {
  //       toastifyResponse(response, "failed");
  //     }
  //   } catch (error) {
  //     console.error("Error notifying employee about anomalies:", error);
  //   } finally {
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       shouldClosePopover: true,
  //     }));
  //   }
  // }, [item.employee?.id]);

  return (
    <SimplePopover
      buttonType="icon"
      buttonContent={<FontAwesomeIcon icon={faEllipsisH} />}
      customButtonStyle={{
        color: lighten(theme.palette.primary.main, 0.5),
        padding: "8px",
      }}
      shouldClose={state.shouldClosePopover}
    >
      <SendAnomaliesNotificationsWrapper
        item={item as unknown as TnADayDataDTO}
        handleNotifyParent={handleNotify}
        customButtonStyle={{
          minWidth: "200px",
          width: "fit-content",
          justifyContent: "flex-start",
          textTransform: "none",
          color: theme.palette.primary.main,
          fontSize: "14px",
        }}
        buttonText={t(`${tRP}.notify_employee_about_anomaly`)}
        buttonTitle={t(`${tRP}.notify_employee_about_anomaly`)}
        disabled={state.loading}
      >
        {/* <Grid> */}
        {/* <Button
            variant="text"
            // onClick={handleNotifyEmployee}
            disabled={state.loading}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              color: theme.palette.primary.main,
              // width: "200px",
              // textWrap: "nowrap",
            }}
          >
            {t(`${tRP}.notify_employee_about_anomaly`)}
          </Button> */}
        {/* </Grid> */}
      </SendAnomaliesNotificationsWrapper>
    </SimplePopover>
  );
};

export default AnomaliesActions;
